import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	durationInHours: {
		id: 'servicedesk-sla-settings.common.utils.duration.duration-in-hours',
		defaultMessage: '{duration}h',
		description: 'duration displayed in Hours',
	},
	durationInMinutes: {
		id: 'servicedesk-sla-settings.common.utils.duration.duration-in-minutes',
		defaultMessage: '{duration}m',
		description: 'duration displayed in Minutes',
	},
});
